export const SideMenuDataCompany = {
  1: {
    name: "Dashboard",
    icon: "fa-solid fa-gauge",
    link: "/",
    AccessCode: "",
    requireStationId: false,
  },
  2: { label: "Fuel Companies & Owners" },
  3: {
    name: "Fuel Station Groups",
    icon: "fa-solid fa-building",
    link: "/fuel_station_Groups/groups_page",
    AccessCode: "VIEW-GROUP",
    requireStationId: false,
  },

  4: {
    name: "Fuel Suppliers",
    icon: "fa-solid fa-parachute-box",
    link: "/fuel_suppliers/view",
    AccessCode: "VIEW-SUPP",
    requireStationId: false,
  },
  5: { label: "Fuel Stations Works" },
  6: {
    name: "Fuel Stations",
    icon: "fa-brands fa-artstation",
    link: "/fuel_stations/view_fuel_stations",
    AccessCode: "VIEW-STATIONS",
    requireStationId: false,
  },
  15: { label: "Users And Shifts" },
  16: {
    name: "Company Level User",
    icon: "fa-solid fa-heading",
    link: "/comapny_users/view",
    AccessCode: "VIEW-COMP-USES",
    requireStationId: false,
  },
  20: {
    name: "Roles",
    icon: "fa-solid fa-heading",
    link: "/users/roles",
    AccessCode: "GIVE-PERMISSION",
    requireStationId: false,
  },
  21: {
    name: "Permissions",
    icon: "fa-solid fa-heading",
    link: "/users/permissions",
    AccessCode: "VIEW-PERMISSION",
    requireStationId: false,
  },
};
